<template>

  <section class="dashboard">
    <DashboardTitle
      title="Clabes interbancarias"
      description="Aquí podrás encontrar la información de todas
        tus clabes dadas de alta, así como su estatus.">
    </DashboardTitle>
    <transition name="fade" mode="out-in">
      <Preloader v-if="!viewIsReady"></Preloader>
      <div v-if="viewIsReady">
        <InvestorClabeResume :totalClabes="totalClabes" />
        <div class="box-filters" v-if="totalClabes !== 0">
          <div class="row row-responsive">
            <div class="column column-sm-100">
              <div class="modal-investment-buttons -centered-info">
                <button
                  class="button button-block"
                  @click="$modal.show('add-new-clabe')">
                  Dar de alta una nueva clabe
                </button>
              </div>
            </div>
          </div>
        </div>
        <InvestorClabeTable
          :object="clabesList" v-if="!emptyClabes">
        </InvestorClabeTable>
      </div>
    </transition>
      <transition name="fade" mode="out-in">
      <div class="box-no-investments -centered-info"
        v-if="emptyClabes">
        <h4 class="maintitle">No tienes clabes registradas</h4>
        <button
          class="button button-block"
          @click="$modal.show('add-new-clabe')">
          Dar de alta una nueva clabe
        </button>
      </div>
    </transition>
    <modal
      name="add-new-clabe"
      classes="modal-investment v--modal-box v--modal"
      height="auto" width="100%" :maxWidth="600" :adaptive="true">
      <InvestorClabeAddNew>
      </InvestorClabeAddNew>
    </modal>
  </section>

</template>

<script>

import DashboardTitle from '@/components/SignedTitle'
import InvestorClabeResume from '@/views/investorClabe/InvestorClabeResume'
import InvestorClabeTable
  from '@/views/investorClabe/InvestorClabeTable'
import InvestorClabeAddNew from '@/views/investorClabe/InvestorClabeAddNew'
import Preloader from '@/components/Preloader'

import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'InvestorClabe',
  metaInfo () {
    return {
      title: 'Panel de clabes interbancarias'
    }
  },
  components: {
    Preloader,
    DashboardTitle,
    InvestorClabeResume,
    InvestorClabeTable,
    InvestorClabeAddNew
  },
  mixins: [httpRequestMixin],
  data () {
    return {
      balance: {
        balance: 0,
        activeInvestments: 0,
        averageRate: 0
      },
      clabesList: [],
      totalClabes: 0,
      emptyClabes: false,
      viewIsReady: false
    }
  },
  created: async function () {
    this.getClabes()
  },
  methods: {
    getClabes: async function () {
      let options = {
        method: 'GET',
        url: this.checkProtocol(process.env.AUTH_BASE + '/investors/clabes/'),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          limit: 10
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.virtualAccoutsList = response.data.balance
          this.viewIsReady = true
          this.clabesList = response.data
          this.totalClabes = response.data.results.length
          if (this.totalClabes === 0) { this.emptyClabes = true }
        }
      }
    }
  }
}

</script>

<style lang="scss">

.modal-investment .modal-content .title {
  float: none;
  margin: .5rem 0 0;
  max-width: 85%;
  font-weight: 300;
  font-size: 1.3em;
}

.-legend {
  font-size: .85em;
  font-style: italic;
}

.modal-investment-buttons {
  text-align: center;

  &.-align-right {
    text-align: right;
  }

  .button {
    width: 100%;

    > img {
      vertical-align: middle;
    }
  }

  @media (min-width: 42rem) {
    .button {
      width: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/InvestorClabe.vue